(() => {
  document.documentElement.classList.remove('no-js');
  const header = document.querySelector('[data-header]');
  const onScroll = () => header?.classList.toggle('is-scrolled', window.scrollY > 20);
  onScroll(); addEventListener('scroll', onScroll, {passive:true});

  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  toggle?.addEventListener('click', () => {
    const open = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('menu-open', open);
  });

  document.querySelectorAll('[data-language-select]').forEach(select => select.addEventListener('change', () => select.form.submit()));

  const reveal = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) {e.target.classList.add('is-visible'); io.unobserve(e.target);} }), {threshold:.1, rootMargin:'0px 0px -5% 0px'});
    reveal.forEach(el => io.observe(el));
  } else reveal.forEach(el => el.classList.add('is-visible'));

  document.querySelectorAll('[data-hero-slider]').forEach(slider => {
    const slides=[...slider.querySelectorAll('[data-slide]')], dots=[...slider.querySelectorAll('[data-hero-dot]')];
    if(slides.length<2) return;
    let current=0,timer; const delay=Number(slider.dataset.autoplay)||7000;
    const show=i=>{current=(i+slides.length)%slides.length;slides.forEach((s,n)=>s.classList.toggle('is-active',n===current));dots.forEach((d,n)=>d.classList.toggle('is-active',n===current));};
    const start=()=>{clearInterval(timer);if(!matchMedia('(prefers-reduced-motion: reduce)').matches) timer=setInterval(()=>show(current+1),delay)};
    slider.querySelector('[data-hero-prev]')?.addEventListener('click',()=>{show(current-1);start()});
    slider.querySelector('[data-hero-next]')?.addEventListener('click',()=>{show(current+1);start()});
    dots.forEach((d,i)=>d.addEventListener('click',()=>{show(i);start()})); start();
  });

  document.querySelectorAll('[data-product-section]').forEach(section => {
    const price = section.querySelector('[data-product-price]');
    section.querySelectorAll('[data-variant-radio]').forEach(radio => radio.addEventListener('change', () => { if (radio.checked && price) price.textContent = radio.dataset.price; }));
  });
})();
